import { ReportCoverSheet, ReportType } from '../enum/report.enum';

export function canUserSeeFullReport(params: {
  isReportCreator: boolean;
  hasTenantManagePrivilege: boolean;
  canAccessAllSubjectsInClass: boolean;
}): boolean {
  return params.isReportCreator || params.hasTenantManagePrivilege || params.canAccessAllSubjectsInClass;
}

export function isAmbiguousReportCompetencePerformanceLevel(averagePerformanceLevel: number): boolean {
  // Return true when the fractional part of the number is between x.25 and x.75
  // For example: 1.30 -> fractional part 0.30 -> true
  // We treat the interval as inclusive: [0.25, 0.75].
  // Handle invalid inputs defensively.
  if (
    typeof averagePerformanceLevel !== 'number' ||
    !isFinite(averagePerformanceLevel) ||
    isNaN(averagePerformanceLevel)
  ) {
    return false;
  }

  // Use value - floor(value) to get the fractional part in [0, 1).
  // This works for positive and negative values: e.g. -1.3 -> -1.3 - (-2) = 0.7
  const rawFraction = averagePerformanceLevel - Math.floor(averagePerformanceLevel);

  // Guard against floating point precision issues by rounding to 12 decimals.
  const fraction = Math.round(rawFraction * 1e12) / 1e12;

  return fraction >= 0.25 && fraction <= 0.75;
}

/** Notes reports have their own covers (note, flower); an own image fits every report type. */
export function isCoverSheetOfReportType(coverSheet: ReportCoverSheet, reportType: ReportType): boolean {
  if (coverSheet === ReportCoverSheet.withCustomImage) return true;
  const isNotesReportCoverSheet =
    coverSheet === ReportCoverSheet.withNote || coverSheet === ReportCoverSheet.withFlower;
  return isNotesReportCoverSheet === (reportType === ReportType.notesReport);
}
